import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.191 12.775a4.083 4.083 0 0 0-.846-1.322c-.875-.901-1.97-1.583-3.262-2.002L9.01 12.524 5.932 9.445c-1.299.419-2.399 1.103-3.278 2.008a4.063 4.063 0 0 0-.845 1.322L0 17.25h18l-1.809-4.475zM9.01 9.25c2.449 0 3.49-2.298 3.49-4.359C12.5 2.751 11.48.75 9.01.75 6.541.75 5.5 2.731 5.5 4.891c0 2.12 1.02 4.359 3.51 4.359z" />
  </svg>
);

export default SvgComponent;
